import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-outletsettings',
  templateUrl: './outletsettings.component.html',
  styleUrls: ['./outletsettings.component.css']
})
export class OutletsettingsComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  taxtypeColl: any = null;
  //Edit Get Values
  companyColl: any = [];
  companyid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  currencyColl: any = [];

  companyform = new FormGroup({
    companyid: new FormControl(0),
    gstno: new FormControl(''),
    fssaino: new FormControl(''),
    currencyid: new FormControl(null),
    taxtype: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "OutletSettings";



  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, public router: Router,
    private loginService: LoginDataService, private confirmationDialogService: ConfirmationDialogService) {

    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.companyform.reset();
      this.fnInitializeCompany();
      this.companyid = this.loginService.fnGetCompanyId();

      if (this.companyid > 0) {
        this.fngetCompany();
      }
      this.fngetTaxType();
      this.fngetCurrency();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeCompany() {

    this.companyform.setValue({
      companyid: 0,
      gstno: '',
      fssaino: '',
      taxtype: '',
      currencyid: null,
      inactive: false,
    })
  }

  fngetTaxType() {
    this.taxtypeColl = [];
    this.taxtypeColl.push({ value: 'GST', displayname: 'GST' })
    this.taxtypeColl.push({ value: 'VAT', displayname: 'VAT' })
  }

  fngetCurrency() {
    var data = {
      'currencyid': 0,
      'companyid': 0,

    }
    this.appService.getCurrencyListview(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            this.currencyColl = res.json().result;

          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {

          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetCompany() {

    var data = {
      'companyid': this.companyid,
    }
    this.appService.getCompany(data)
      .subscribe(
        (res) => {
          this.companyColl = res.json().result;
          var editdata = this.companyColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.companyform.valid) {
        // this.saveloading = true
        //Check

        var data = {
          'companyid': this.companyid,
          'gstno': this.companyform.get('gstno').value,
          'fssaino': this.companyform.get('fssaino').value,
          'taxtype': this.companyform.get('taxtype').value,
          'currencyid': this.companyform.get('currencyid').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        if (this.companyform.get('companyid').value > 0) {
          //Update Department
          this.fnSetCompany(data);
        }
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  // fnInsertCompany(data) {

  //   this.appService.fnInsertCompany(data).subscribe(
  //     (res) => {
  //       this.saveloading=false

  //       if (res.json().result != "") {
  //         this.toastr.success('', "The new Company has been added successfully.Insert Successfully");

  //         this.fnInsertActivityLog('INSERT', 0, data.companyid);

  //         this.emitData.emit(this.companyid);
  //         this.activeModal.close(true);
  //       }
  //     },
  //     (err) => {
  //       this.saveloading=false

  //       this.toastr.error('Error', err);
  //     });

  // }

  //Set
  fnSetCompany(data) {

    this.appService.fnSetCompany(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The Outlet Settings has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.companyid, data.companyname);
          this.fnCloseCompany();
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.companyform.setValue({

      companyid: deptBO.companyid,
      gstno: deptBO.gstno,
      fssaino: deptBO.fssaino,
      taxtype: deptBO.taxtype,
      currencyid: deptBO.currencyid,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  //Close
  fnCloseCompany() {
    try {
      this.router.navigate(['/Configration']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }







  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
